// extracted by mini-css-extract-plugin
export default {"root":"Image-module-root-1PD","imageContainer":"Image-module-imageContainer-4U7","link":"Image-module-link-1by"};